'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _getAccentColor = require('conversations-schema/operators/coloring/getAccentColor');

var _ChatBubble = require('ui-addon-messages/chat-message/ChatBubble');

var _ChatBubble2 = _interopRequireDefault(_ChatBubble);

var _ChatMessageText = require('./ChatMessageText');

var _ChatMessageText2 = _interopRequireDefault(_ChatMessageText);

var _AutomatedChatMessageBotAvatar = require('./AutomatedChatMessageBotAvatar');

var _AutomatedChatMessageBotAvatar2 = _interopRequireDefault(_AutomatedChatMessageBotAvatar);

var _MessageWrapper = require('./MessageWrapper');

var _MessageWrapper2 = _interopRequireDefault(_MessageWrapper);

var _InboxChatBubbleTooltip = require('./InboxChatBubbleTooltip');

var _InboxChatBubbleTooltip2 = _interopRequireDefault(_InboxChatBubbleTooltip);

var _SenderTypePropType = require('../prop-types/SenderTypePropType');

var _SenderTypePropType2 = _interopRequireDefault(_SenderTypePropType);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutomatedChatMessage = function (_React$PureComponent) {
  _inherits(AutomatedChatMessage, _React$PureComponent);

  function AutomatedChatMessage() {
    _classCallCheck(this, AutomatedChatMessage);

    return _possibleConstructorReturn(this, (AutomatedChatMessage.__proto__ || Object.getPrototypeOf(AutomatedChatMessage)).apply(this, arguments));
  }

  _createClass(AutomatedChatMessage, [{
    key: 'isOwnMessage',
    value: function isOwnMessage() {
      var _props = this.props,
          currentRole = _props.currentRole,
          messageRole = _props.messageRole;

      return messageRole === currentRole || messageRole === _senderTypes.SYSTEM && this.isAdmin();
    }
  }, {
    key: 'isAdmin',
    value: function isAdmin() {
      var currentRole = this.props.currentRole;

      return currentRole === _senderTypes.AGENT;
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var align = this.isOwnMessage() ? _ChatBubble.alignment.RIGHT : _ChatBubble.alignment.LEFT;
      var use = this.isAdmin() ? _ChatBubble.uses.INBOX : _ChatBubble.uses.DEFAULT;

      var bubble = _react2.default.createElement(
        _ChatBubble2.default,
        {
          align: align,
          isFirstInGroup: this.props.isFirstInGroup,
          isLastInGroup: this.props.isLastInGroup,
          use: use
        },
        _react2.default.createElement(_ChatMessageText2.default, {
          message: this.props.message,
          useAutoLinker: this.props.useAutoLinker
        })
      );

      return this.isAdmin() ? _react2.default.createElement(
        _InboxChatBubbleTooltip2.default,
        {
          title: this.props.bubbleTooltip,
          placement: align === _ChatBubble.alignment.RIGHT ? 'right' : 'left'
        },
        bubble
      ) : bubble;
    }
  }, {
    key: 'render',
    value: function render() {
      var coloring = this.props.coloring;


      return _react2.default.createElement(
        _MessageWrapper2.default,
        {
          dataSeleniumTest: 'automated-chat-message',
          avatar: _react2.default.createElement(_AutomatedChatMessageBotAvatar2.default, { color: (0, _getAccentColor.getAccentColor)(coloring) }),
          isOwnMessage: this.isOwnMessage(),
          isAdmin: this.isAdmin(),
          isLastInGroup: this.props.isLastInGroup
        },
        this.renderContent()
      );
    }
  }]);

  return AutomatedChatMessage;
}(_react2.default.PureComponent);

AutomatedChatMessage.propTypes = {
  bubbleTooltip: _react.PropTypes.node,
  coloring: (0, _RecordPropType2.default)('ColoringRecord'),
  currentRole: _SenderTypePropType2.default.isRequired,
  isFirstInGroup: _react.PropTypes.bool,
  isLastInGroup: _react.PropTypes.bool,
  message: (0, _RecordPropType2.default)('PubNubMessageRecord').isRequired,
  messageRole: _SenderTypePropType2.default.isRequired,
  useAutoLinker: _react.PropTypes.bool.isRequired
};

AutomatedChatMessage.defaultProps = {
  useAutoLinker: true
};

exports.default = AutomatedChatMessage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/AutomatedChatMessage.js
// module id = 1116
// module chunks = 2 3